import * as React from 'react';
import { graphql } from 'gatsby';
import ContextConsumer from '../helpers/context';

import Template from '../templates/policy';

const PolitykaPage = ({ data }) => {
  
  const policy = data.med.pagePolicy;

  return (
    <ContextConsumer>
      {({ data, set }) => (
        <Template
          contextData={data}
          contextSet={set}
          langTo={'/en/privacy-policy'}
          data={policy}
        />
      )}
    </ContextConsumer>
  );
};

export const pagePolitykaQuery = graphql`
  {
    med {
      pagePolicy(where: { id: "ckylfxauwn3lz0b542avzh4vz" }, locales: pl_PL) {
        content {
          markdown
          html
          raw
        }
        seoDescription
        seoImage {
          url
        }
        seoTitle
      }
    }
  }
`;

export default PolitykaPage;
